<template>
  <Form :data="form" :data_status="status" :data_user="user" :data_tangki="tangki" :data_ternakan="lkp_ternakan" :data_lkp_baka="lkp_baka" :data_baka_jantan="baka_jantan" :data_baka_straw="baka_straw" :data_lkp_baka_induk="lkp_baka_induk" :data_baka_betina="baka_betina" :data_baka_straw_induk="baka_straw_induk" v-if="form.id > 0 && load == 11"/>
  <Form :data="form" :data_status="status" :data_user="user" :data_tangki="tangki" :data_ternakan="lkp_ternakan" :data_lkp_baka="lkp_baka" :data_baka_jantan="baka_jantan" :data_baka_straw="baka_straw" :data_lkp_baka_induk="lkp_baka_induk" :data_baka_betina="baka_betina" :data_baka_straw_induk="baka_straw_induk" v-else-if="load == 4"/>
</template>
<script>
import { reactive } from 'vue'
import Form from "./_Form.vue";
export default {
  components: {
    Form
  },
  props: {
   id: [Array, Object],
  },
  data() {
    return {
      load : 0,
      tangki : [],
      status : [],
      user : [],
      lkp_ternakan : [],
      lkp_baka : [],
      baka_jantan : [],
      baka_straw : [],
      lkp_baka_induk : [],
      baka_betina : [],
      baka_straw_induk : [],
      form : {
        id : 0,
        lkp_ternakan_id: 0,
        lkp_baka_id:'',
        baka_id: '',
        baka_straw_id:'',
        tangki_id:'',
        lkp_baka_induk_id:'',
        baka_induk_id:'',
        baka_straw_induk_id:'',
        lkp_status_id:'',
        jantina: '',
        tarikh: '',
        amaun: '',
        kode: '',
        p : 0,
      },
    }
  },
  methods: {
    getData()
    {
      this.$zcomm.get(this.api_service + 'embrio/show/'+this.id, {}).then(res => {
        this.form = res
        this.getBaka(this.form.lkp_ternakan_id);
        this.getBakaInduk(this.form.lkp_ternakan_id);
        this.getBakaJantan(this.form.lkp_baka_id);
        this.getbakaStraw(this.form.baka_id);
        this.getBakaBetina(this.form.lkp_baka_induk_id);
        this.getbakaStrawBetina(this.form.baka_induk_id);
         this.load = this.load + 1;
      })
    },
    getTernakan(){
      this.$zcomm.get(this.api_service + 'lookup/ternakan', {}).then(res => {
        this.lkp_ternakan = res
         this.load = this.load + 1;
      })
      
    },
    getStatus(){
      this.$zcomm.get(this.api_service + 'lookup/status_insemination', {}).then(res => {
        this.status = res
        this.load = this.load + 1;
      })
    },
    getUser(){
      this.$zcomm.get(this.api_service + 'lookup/alman', {}).then(res => {
        this.user = res
        this.load = this.load + 1;
      })
    },

    getTangki(){
      this.$zcomm.get(this.api_service + 'lookup/tangki_embrio', {}).then(res => {
        this.tangki = res
        this.load = this.load + 1;
      })
    },
    getBaka(id){
      this.$zcomm.get(this.api_service + 'lookup/baka/'+id, {}).then(res => {
        this.lkp_baka = res
        this.load = this.load + 1;
      })
      
    },
    getBakaJantan(id){
      this.$zcomm.get(this.api_service + 'lookup/baka_jantan/'+id, {}).then(res => {
        this.baka_jantan = res
        this.load = this.load + 1;
      })
    },

    getbakaStraw(id){
      this.$zcomm.get(this.api_service + 'lookup/semen/'+id, {}).then(res => {
        this.baka_straw = res
        if(this.form.baka_straw_id > 0){
          this.baka_straw.push({value: this.form.baka_straw_id, label : this.form.semen})
        }
        this.load = this.load + 1;
      })
    },
    getBakaBetina(id){
      this.$zcomm.get(this.api_service + 'lookup/baka_betina/'+id, {}).then(res => {
        this.baka_betina = res
        this.load = this.load + 1;
      })
    },
    getBakaInduk(id){
      this.$zcomm.get(this.api_service + 'lookup/baka/'+id, {}).then(res => {
        this.lkp_baka_induk = res
        this.load = this.load + 1;
      })
    },

    getbakaStrawBetina(id){
      this.$zcomm.get(this.api_service + 'lookup/sel_telur/'+id, {}).then(res => {
        this.baka_straw_induk = res
        if(this.form.baka_straw_induk_id > 0){
          this.baka_straw_induk.push({value: this.form.baka_straw_induk_id, label : this.form.sel_telur})
        }
        this.load = this.load + 1;
      })
    },

  },

  watch: {

  },
  mounted() {
    this.getStatus()
    this.getUser()
    this.getTangki()
    this.getTernakan()
    if(this.id > 0)
    {
      this.getData()
    }
  }
    
}
</script>
